import { render, staticRenderFns } from "./RsaSchedaPazienteViewComponent.vue?vue&type=template&id=075aca58"
import script from "./RsaSchedaPazienteViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPazienteViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports